import PropTypes from 'prop-types';
import Form, {
  FormGroup,
  FormControl,
  TextFieldControl,
  EmailFieldControl,
  TextAreaControl,
  CountryFieldControl,
  PhoneFieldControl,
  FormActions,
  FormSubmit,
  submitForm,
} from '@/components/Forms';
import { notifySuccess, notifyError } from '@/components/Toaster';

const defaultProps = {
  onSuccess: () => notifySuccess(`
    Tu mensaje se ha enviado. Uno de nuestros agentes se
    estará poniendo en contacto lo más pronto posible.
  `),
  onError: () => notifyError(`
    Ha ocurrido un error cuando intentamos enviar tu mensaje.
    Por favor inténtalo nuevamente.
  `),
};

const propTypes = {
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
};

export default function PartnerApplyForm({
  onSuccess,
  onError,
}) {
  return (
    <Form
      initialValues={{
        firstname: '',
        lastname: '',
        company: '',
        email: '',
        country: '',
        phone: '',
        message: '',
      }}
      onSubmit={(values, {
        setSubmitting,
        resetForm,
      }) => {
        submitForm('7663692/4e9c01cd-4011-467b-bf36-8a26d9673782', values, {
          setSubmitting,
          onSuccess: function() {
            resetForm();
            onSuccess();
          },
          onError: function(errors) {
            onError();
          },
        })
      }}
    >
      {({
        handleChange,
        handleBlur,
        setFieldValue,
        validateForm,
        isSubmitting,
        errors,
        touched,
        values,
      }) => {
        const countryHasError   = touched.country   && errors.country   !== undefined;
        const phoneHasError     = touched.phone     && errors.phone     !== undefined;

        return (
          <div className="flex flex-col space-y-4 lg:space-y-6 w-full">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="md:col-span-1 space-y-4 lg:space-y-6">
                <FormGroup>
                  <FormControl htmlFor="firstname" label="Nombres">
                    <TextFieldControl
                      id="firstname"
                      name="firstname"
                      placeholder="Juan"
                      onChange={handleChange}
                      value={values.firstname}
                      disabled={isSubmitting}
                      required
                    />
                  </FormControl>
                </FormGroup>
              </div>
              <div className="md:col-span-1 space-y-4 lg:space-y-6">
                <FormGroup>
                  <FormControl htmlFor="lastname" label="Apellidos">
                    <TextFieldControl
                      id="lastname"
                      name="lastname"
                      placeholder="Díaz"
                      onChange={handleChange}
                      value={values.lastname}
                      disabled={isSubmitting}
                      required
                    />
                  </FormControl>
                </FormGroup>
              </div>
            </div>
            <FormGroup>
              <FormControl htmlFor="company" label="Empresa">
                <TextFieldControl
                  id="company"
                  name="company"
                  placeholder="Agile Company"
                  onChange={handleChange}
                  value={values.company}
                  disabled={isSubmitting}
                  required
                />
              </FormControl>
            </FormGroup>
            <FormGroup>
              <FormControl htmlFor="email" label="Correo electrónico de trabajo">
                <EmailFieldControl
                  id="email"
                  name="email"
                  placeholder="juan.diaz@ejemplo.com"
                  onChange={handleChange}
                  value={values.email}
                  disabled={isSubmitting}
                  required
                />
              </FormControl>
            </FormGroup>
            <FormGroup>
              <FormControl htmlFor="phone" label="Teléfono">
                <PhoneFieldControl
                  id="phone"
                  name="phone"
                  placeholder="+5 (555) 555-5555"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.phone}
                  disabled={isSubmitting}
                  error={errors.phone}
                  hasError={phoneHasError}
                  required
                />
              </FormControl>
            </FormGroup>
            <FormGroup>
              <FormControl htmlFor="country" label="País">
                <CountryFieldControl
                  htmlId="country"
                  name="country"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  setFieldValue={setFieldValue}
                  validateForm={validateForm}
                  value={values.country}
                  disabled={isSubmitting}
                  error={errors.country}
                  hasError={countryHasError}
                  required
                />
              </FormControl>
            </FormGroup>
            <FormGroup>
              <FormControl htmlFor="message" label="Mensaje">
                <TextAreaControl
                  id="message"
                  name="message"
                  onChange={handleChange}
                  value={values.message}
                  disabled={isSubmitting}
                />
              </FormControl>
            </FormGroup>
            <FormActions>
              <FormSubmit
                label="Comenzar el proceso"
                submitting={isSubmitting}
              />
            </FormActions>
          </div>
        );
      }}
    </Form>
  );
}

PartnerApplyForm.defaultProps = defaultProps;
PartnerApplyForm.propTypes = propTypes;
